import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Container from "components/core/Page/Container";
import SectionHeader from "components/molecules/SectionHeader";
import sizeComparisonHeaderImage from "assets/icons/psp/illustration-multiple-sites.svg";
import ComparisonSection from "./ComparisonSection";

import "./SizeComparison.scss";

function SizeComparisonModule(props) {
	const {
		pageType = "psp",
		title = "",
		description = "",
		image,
		sizes = [],
		postModuleDescription = "",
		background = "light-blue"
	} = props;
	return (
		<section className={classNames("size-comparison-section", background)}>
			<Container className="container-scm">
				<SectionHeader
					title={title}
					description={description}
					contentAlign="text-center"
					additionalProps={{
						paragraph: {
							size: "standard",
							color: "black",
							weight: "regular"
						}
					}}
					titleProps={{
						size: "xxlarge",
						weight: "bold",
						color: "black"
					}}
					className={`${pageType.toLowerCase()}-header`}
					image={image || sizeComparisonHeaderImage}
				/>
				<ComparisonSection
					sizes={sizes}
					postModuleDescription={postModuleDescription}
				/>
			</Container>
		</section>
	);
}

SizeComparisonModule.propTypes = {
	pageType: PropTypes.oneOf(["psp", "sgp"]),
	title: PropTypes.string,
	description: PropTypes.string,
	image: PropTypes.string,
	sizes: PropTypes.arrayOf(PropTypes.object),
	postModuleDescription: PropTypes.string,
	background: PropTypes.oneOf(["light-blue", "white"])
};

export default SizeComparisonModule;
